import { useFieldContext } from '@/lib/form-contexts'
import { cn } from '@/lib/utils'
import { Typography } from '@/components/ui/typography'

export type FieldInfoProps = {
  className?: string
}

const getErrorText = (error: unknown) => {
  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    return error.message
  }

  return String(error)
}

function FieldInfo({ className }: FieldInfoProps) {
  const field = useFieldContext<unknown>()
  return (
    <>
      {field.state.meta.errors.length > 0 && (
        <Typography
          as="em"
          variant="supporting"
          tone="destructive"
          italic
          className={cn('block', className)}
        >
          {field.state.meta.errors.map(getErrorText).join(', ')}
        </Typography>
      )}
    </>
  )
}

export default FieldInfo
